import config from 'emun.retailer/retailer.config'
import $appConfig from 'servicestack/config'
import templateUrl from 'emun.order/order-details-tabs.htm'
import CartController from 'emun.cart/cart.controller'
import OrderDetailsPrompt from 'emun.order/order-details-prompt'
import orderConfig from 'emun.order/order.config'
import cartConfig from 'emun.cart/cart.config'

export class OrderDetailsTabsController extends CartController {
    constructor($cart, $state, $stateParams) {
        super($cart)
        let $ctrl = this;
        $ctrl.config = config;
        $ctrl.orderConfig = orderConfig;
        $ctrl.cartConfig = cartConfig;
    }
    $onInit() {
        let $ctrl = this;
        $ctrl.active = $ctrl.isEditable ? 1 : 0;
        $ctrl.mode = $ctrl.order.status === 'Quote' ? 'Quote' : 'Order';
    }
}

export default {
    bindings: {
        order: '<',
        mode: '<',
        isEditable: '<',
    },
    //require: {
    //    container: '^orderView'
    //},
    controller: OrderDetailsTabsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};